import { useState } from "react";
import { Program } from "@platform/types/platform.types";
import { useOnboardingStep } from "@platform/features/onboarding/hooks/useOnboardingStep";
import { FriendInvitationForm } from "../FriendInvitationForm/FriendInvitationForm";
import { FriendInvitationUnsure } from "../FriendInvitationUnsure/FriendInvitationUnsure";
import { FriendInvitationSuccess } from "../FriendInvitationSuccess/FriendInvitationSuccess";
import { FriendInvitationIntro } from "../FriendInvitationIntro/FriendInvitationIntro";

type viewType = "intro" | "invite" | "unsure" | "success";

type Props = {
  program: Program;
  onDone: () => void;
};

export function FriendInvitationContainer({ program, onDone }: Props) {
  const { completeStep } = useOnboardingStep();

  const [viewType, setViewType] = useState<viewType>("intro");

  const handleContinue = () => {
    setViewType("invite");
    completeStep("invite-intro");
  };

  const handleSkip = () => {
    setViewType("unsure");
    completeStep("invite");
  };

  return (
    <>
      {viewType === "intro" && (
        <FriendInvitationIntro onContinue={handleContinue} />
      )}
      {viewType === "invite" && (
        <FriendInvitationForm
          program={program}
          onSkip={handleSkip}
          onContinue={() => setViewType("success")}
        />
      )}
      {viewType === "unsure" && (
        <FriendInvitationUnsure onBack={handleContinue} onContinue={onDone} />
      )}
      {viewType === "success" && (
        <FriendInvitationSuccess onContinue={onDone} />
      )}
    </>
  );
}

export default FriendInvitationContainer;
